import { createSelector } from "reselect";
import { getFormValues } from "redux-form";

function getTypes(state){
	return state.versionDetails.types || [];
}

function getSelectedTypes(state){
	return state.versionDetails.selectedTypes || [];
}

function getSearchTerm(state){
	return state.versionDetails.searchTerm || "";
}

function getEditVersionValues(state, form){
	return getFormValues(form)(state);
}

export const allowedTypes = createSelector([getTypes, getSelectedTypes], (types, selectedTypes) => {
	/*
		These are the types that are allowed to be shown, based on the toggle filter selection (selectedTypes),
		which starts out with an empty set, but should allow all types, then only show the
		`selectedTypes` if they're specified.
	*/
	return selectedTypes.length ? selectedTypes : types;
});

function filterEditVersionValues(values = {}, searchTerm, allowedTypes){
	/*
		`values` is a hash of form values.  We want to return a hash where some entries
		are removed, based on the `allowedTypes` and the `searchTerm` (which must appear in either
		the name or the data properties of the value).
	*/
	let searchString = searchTerm.toLowerCase();

	let filteredValues = Object.entries(values).reduce((prev, [key, value]) => {
		let { type, name, data } = value;

		if(!allowedTypes.includes(type)){
			return prev;
		}
		if(searchTerm){ // Only filter if a searchTerm is specified
			// We have to use optional chaining around `data` because social versions can be `null|undefined` whereas other versions are ""
			if(name.toLowerCase().includes(searchString) || data?.toLowerCase()?.includes(searchString)){
				/*
					We just use String.includes to test because it's fast, and `searchString` comes from the
					user, and we don't want to confuse people with unintentional regex matching or anything.

					We'll return prev either way in this `searchTerm` branch, but only add the entry to it
					if the string is found.
				*/
				prev[key] = value;
			}
			return prev;
		}

		prev[key] = value;
		return prev;
	}, {});

	return filteredValues;
}

export const filteredEditVersionValues = createSelector([getEditVersionValues, getSearchTerm, allowedTypes], filterEditVersionValues);
